var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "s-orders-nav"
  }, [_c('div', {
    staticClass: "s-basis-1/4"
  }, [_c('button', {
    staticClass: "s-orders-btn ml-3 pl-3 pr-3",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])]), _c('div', {
    staticClass: "text-center s-basis-1/2"
  }, [_vm._v(_vm._s(_vm.getConfig('form_title')))])]), _vm.fetching ? _c('p', [_c('Loading')], 1) : [_vm.fieldSetting.length > 0 ? _c('DetailSection', {
    staticClass: "m-3",
    attrs: {
      "icon": "info",
      "title": "資訊"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_vm.fieldSetting.length > 0 ? _vm._l(_vm.fieldSetting, function (field, i) {
    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "s-font-semibold s-text-primary-text"
    }, [_vm._v(_vm._s(field.value))]), _c('td', {
      staticClass: "s-text-right s-text-black"
    }, [_vm._v(_vm._s(_vm.object[field.key]))])]);
  }) : _vm._e()], 2)]) : _vm._e(), _vm.itemFieldSetting.length > 0 ? _c('DetailSection', {
    staticClass: "m-3",
    attrs: {
      "icon": "list",
      "title": "明細"
    }
  }, [_c('table', {
    staticClass: "s-text-sm s-w-full"
  }, [_c('thead', [_c('tr', {
    staticClass: "s-font-semibold"
  }, [_vm.itemFieldSetting.length > 0 ? _vm._l(_vm.itemFieldSetting, function (field, i) {
    return _c('th', {
      key: i,
      class: _vm.itemThClass(i)
    }, [_vm._v(" " + _vm._s(field.value) + " ")]);
  }) : _vm._e()], 2)]), _c('tbody', _vm._l(_vm.items, function (item, i) {
    return _c('tr', {
      key: i
    }, [_vm.itemFieldSetting.length > 0 ? _vm._l(_vm.itemFieldSetting, function (field, j) {
      return _c('td', {
        key: j,
        class: _vm.itemTdClass(j)
      }, [_vm._v(" " + _vm._s(item[field.key]) + " ")]);
    }) : _vm._e()], 2);
  }), 0)])]) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }